import * as React from "react";

import { AgentSpecificationDropdown } from "DistributedTask/Common/Library/AgentSpecificationDropdown";
import { AppContext } from "DistributedTaskControls/Common/AppContext";
import * as Base from "DistributedTaskControls/Common/Components/Base";
import { LoadingComponent } from "DistributedTaskControls/Components/LoadingComponent";
import { IAgentSpecification } from "DistributedTaskControls/Phase/Types";
import { AgentQueueDropdown } from "DistributedTaskControls/SharedControls/InputControls/Components/AgentQueueDropdown";
import { TaskAgentQueue } from "TFS/DistributedTask/Contracts";
import { IVssPageContext } from "VSS/Platform/Context";
import { ReactRootComponent } from "VSS/Platform/Layout";

import "VSS/LoaderPlugins/Css!DistributedTaskControls/Components/AgentQueueSelector";

export interface IProps extends Base.IProps {
    label?: string;
    selectedAgentQueueId: number;
    selectedAgentSpecification?: IAgentSpecification;
    agentSpecificationErrorMessage?: string;
    agentQueues: TaskAgentQueue[];
    agentSpecifications?: IAgentSpecification[];
    isLoadingAgentSpecifications?: boolean;
    onAgentQueueSelected(agentQueueId: number): void;
    onAgentSpecificationSelected?(agentSpecification: IAgentSpecification): void;
    required?: boolean;
    ariaLabel?: string;
    disabled?: boolean;
    onExpand?: any;
}

export class AgentQueueSelector extends Base.Component<IProps, Base.IStateless> {

    public render(): JSX.Element {
        return (
            <div>
                <div className="agent-queue-drop-down-area">
                    <AgentQueueDropdown
                        ref={(element) => { this._dropDownInputControl = element; }}
                        className="agent-queue-drop-down"
                        label={this.props.label}
                        queues={this.props.agentQueues}
                        onChanged={this._handleAgentQueueChanged}
                        selectedAgentQueueId={this.props.selectedAgentQueueId}
                        required={this.props.required}
                        ariaLabel={this.props.ariaLabel || this.props.label}
                        disabled={this.props.disabled}
                        onExpand={this.props.onExpand}
                    />
                    {
                        <div className="agent-queue-drop-down-children">
                            {this.props.children}
                        </div>
                    }
                </div>
                {
                    this.props.onAgentSpecificationSelected && (
                        this.props.isLoadingAgentSpecifications ?
                            <LoadingComponent /> :
                            <ReactRootComponent pageContext={AppContext.instance().PageContext as IVssPageContext}>
                                <AgentSpecificationDropdown
                                    disabled={this.props.disabled}
                                    agentQueue={this.props.agentQueues.find(q => q.id === this.props.selectedAgentQueueId)}
                                    agentSpecifications={this.props.agentSpecifications}
                                    selectedAgentSpecification={this.props.selectedAgentSpecification}
                                    errorMessage={this.props.agentSpecificationErrorMessage}
                                    onChanged={this._handleAgentSpecificationChanged} />
                            </ReactRootComponent>)
                }
            </div>
        );
    }

    public setFocus() {
        if (this._dropDownInputControl) {
            this._dropDownInputControl.focus();
        }
    }

    private _handleAgentQueueChanged = (agentQueue: TaskAgentQueue | null) => {
        this.props.onAgentQueueSelected(agentQueue ? agentQueue.id : 0);
    }

    private _handleAgentSpecificationChanged = (agentSpecification: IAgentSpecification) => {
        this.props.onAgentSpecificationSelected(agentSpecification);
    }

    private _dropDownInputControl: AgentQueueDropdown;
}
